import {QuoteRow} from "./QuoteRow";
import {QuoteAttachment} from "./QuoteAttachment";

export const quoteStatusOptions = {
  'concept': 'Concept',
  'verstuurd': 'Verstuurd',
  'geaccepteerd': 'Geaccepteerd',
  'geweigerd': 'Geweigerd',
  'vervallen': 'Vervallen',
  'afgerond': 'Werk Afgerond',
}
export type QuoteStatus = keyof typeof quoteStatusOptions
export class Quote {
  constructor(
    public readonly id: string,
    public readonly projectId: string,
    public readonly relationId: string,
    public readonly contactId: string|null,
    public readonly quoteNumber: string,
    public readonly description: string,
    public readonly memo: string|null,
    public readonly paymentTerm: number,
    public readonly expirationDate: Date|null,
    public readonly sentAt: Date|null,
    public readonly reference: string|null,
    public readonly status: QuoteStatus,
    public readonly paymentTerms: string|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly archivedAt: Date|null,
    public readonly quoteRows: QuoteRow[],
    public readonly quoteAttachments: QuoteAttachment[],
  ) {
  }

  static fromJson(json: any): Quote {
    return new Quote(
      json['id'],
      json['project_id'],
      json['relation_id'],
      json['contact_id'] ?? null,
      json['quote_number'],
      json['description'],
      json['memo'],
      json['payment_term'],
      json['expiration_date'] ? new Date(json['expiration_date']) : null,
      json['sent_at'] ? new Date(json['sent_at']) : null,
      json['reference'],
      json['status'],
      json['payment_terms'] ?? null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['deleted_at'] ? new Date(json['deleted_at']) : null,
      json['quote_rows'] ? json['quote_rows'].map((qr: any) => QuoteRow.fromJson(qr)) : [],
      json['quote_attachments'] ? json['quote_attachments'].map((qa: any) => QuoteAttachment.fromJson(qa)) : [],
    )
  }
}